import { render, staticRenderFns } from "./FacetSearchDesktop.vue?vue&type=template&id=b9c521ba&"
import script from "./FacetSearchDesktop.vue?vue&type=script&lang=ts&"
export * from "./FacetSearchDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./FacetSearchDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports